// per-route head overrides for non-bio pages keyed by first path segment
// routes without an entry get the default site meta

export interface StaticMeta {
  title: string;
  description?: string;
  canonical?: string;
  noindex?: boolean;
}

const STATIC_META: Record<string, StaticMeta> = {
  docs: {
    title: "docs | clove.moe",
    description:
      "learn how to build your bio page with bml markup or custom html and css",
    canonical: "https://clove.moe/docs",
  },
  privacy: {
    title: "privacy policy | clove.moe",
    description: "privacy policy for clove.moe",
    canonical: "https://clove.moe/privacy",
  },
  terms: {
    title: "terms of service | clove.moe",
    description: "terms of service for clove.moe",
    canonical: "https://clove.moe/terms",
  },
  "sign-in": {
    title: "sign in | clove.moe",
    description: "sign in to your clove.moe account",
    canonical: "https://clove.moe/sign-in",
  },
  "sign-up": {
    title: "sign up | clove.moe",
    description: "create a free clove.moe account",
    canonical: "https://clove.moe/sign-up",
  },
  "forgot-password": {
    title: "forgot password | clove.moe",
    noindex: true,
  },
  "reset-password": {
    title: "reset password | clove.moe",
    noindex: true,
  },
  dashboard: {
    title: "dashboard | clove.moe",
    noindex: true,
  },
  settings: {
    title: "settings | clove.moe",
    noindex: true,
  },
  editor: {
    title: "editor | clove.moe",
    noindex: true,
  },
};

export function staticMetaFor(urlPathname: string): StaticMeta | null {
  const seg = urlPathname.split("/").filter(Boolean)[0];
  return (seg && STATIC_META[seg]) || null;
}
